<template>
    <div>
        <updatesModal ref="elemSelected" v-if="validateUser()"></updatesModal>
        <candidate-banner></candidate-banner>
        <svg class="hidden d-none">
            <defs>
                <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
            </defs>
        </svg>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <candidate-side-nav-layout></candidate-side-nav-layout>
                </div>
                <div class="col-md-9 candidate-dashboard-main-content">
                    <div class="row">
                        <div class="col-md-4"
                             v-if="this.$store.getters.getPreferences['show_jobs'] && this.$store.getters.getPreferences['show_internships']">
                            <div class="db-stat-box">
                                <div class="stat-details">
                                    <div class="db-stat-icon">
                                        <i class="fas fa-briefcase"></i>
                                    </div>
                                    <div class="db-stat-count">{{ jobs_count }}</div>
                                    <div class="db-stat-heading">Applied Applications</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4"
                             v-if="this.$store.getters.getPreferences['show_jobs'] && this.$store.getters.getPreferences['show_internships']">
                            <div class="db-stat-box">
                                <div class="stat-details">
                                    <div class="db-stat-icon">
                                        <i class="far fa-building"></i>
                                    </div>
                                    <div class="db-stat-count">{{ company_count }}</div>
                                    <div class="db-stat-heading">Available Companies</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4"
                             v-if="this.$store.getters.getPreferences['show_jobs'] && this.$store.getters.getPreferences['show_internships']">
                            <div class="db-stat-box">
                                <div class="stat-details">
                                    <div class="db-stat-icon">
                                        <i class="fas fa-list-ul"></i>
                                    </div>
                                    <div class="db-stat-count">{{ shortlist_count }}</div>
                                    <div class="db-stat-heading">Shortlisted Applications</div>
                                </div>
                            </div>
                        </div>
                    </div>
<!--                    <education-loan-webinar></education-loan-webinar>-->
<!--                    <webinar-widget></webinar-widget>-->
<!--                    <div class="row">-->
<!--                        <div class="col-md-12">-->
<!--                            <div class="tab-int-data">-->
<!--                                <ul class="nav nav-tabs material-tabs" id="myTab" role="tablist">-->
<!--                                    <li class="nav-item active">-->
<!--                                        <a class="nav-link" id="all-tab" data-toggle="tab" href="#all" role="tab"-->
<!--                                           aria-controls="all" aria-selected="true">-->
<!--                                            <svg viewBox="0 0 80 60" preserveAspectRatio="none">-->
<!--                                                <use xlink:href="#tabshape"></use>-->
<!--                                            </svg>-->
<!--                                            <span>Campus<br/> Internship Program</span>-->
<!--                                        </a>-->
<!--                                    </li>-->
<!--                                    <li class="nav-item">-->
<!--                                        <a class="nav-link" id="academic-tab" data-toggle="tab" href="#academic"-->
<!--                                           role="tab"-->
<!--                                           aria-controls="academic" aria-selected="false">-->
<!--                                            <svg viewBox="0 0 80 60" preserveAspectRatio="none">-->
<!--                                                <use xlink:href="#tabshape"></use>-->
<!--                                            </svg>-->
<!--                                            <svg viewBox="0 0 80 60" preserveAspectRatio="none">-->
<!--                                                <use xlink:href="#tabshape"></use>-->
<!--                                            </svg>-->
<!--                                            <span>Summer<br/> Internship Program</span>-->
<!--                                        </a>-->
<!--                                    </li>-->
<!--                                    <li class="nav-item">-->
<!--                                        <a class="nav-link" id="general-tab" data-toggle="tab" href="#general"-->
<!--                                           role="tab"-->
<!--                                           aria-controls="general" aria-selected="false">-->
<!--                                            <svg viewBox="0 0 80 60" preserveAspectRatio="none">-->
<!--                                                <use xlink:href="#tabshape"></use>-->
<!--                                            </svg>-->
<!--                                            <svg viewBox="0 0 80 60" preserveAspectRatio="none">-->
<!--                                                <use xlink:href="#tabshape"></use>-->
<!--                                            </svg>-->
<!--                                            <span>Winter<br/> Internship Program</span>-->
<!--                                        </a>-->
<!--                                    </li>-->
<!--                                    <li class="nav-item">-->
<!--                                        <a class="nav-link" id="placement-tab" data-toggle="tab" href="#general"-->
<!--                                           role="tab"-->
<!--                                           aria-controls="general" aria-selected="false">-->
<!--                                            <svg viewBox="0 0 80 60" preserveAspectRatio="none">-->
<!--                                                <use xlink:href="#tabshape"></use>-->
<!--                                            </svg>-->
<!--                                            <span>Campus<br/> Placement Program</span>-->
<!--                                        </a>-->
<!--                                    </li>-->
<!--                                </ul>-->
<!--                                <div class="tab-content" id="myTabContent">-->
<!--                                    <div class="tab-pane fade show active in" id="all" role="tabpanel"-->
<!--                                         aria-labelledby="all-tab">-->
<!--                                        <div class="row">-->
<!--                                            <div class="col-md-6 col-sm-6">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="marks1">Profile</label>-->
<!--                                                    <input type="text" class="form-control dash-input" id="marks1"-->
<!--                                                           placeholder="Enter Profile" name="marks">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div class="col-md-6 col-sm-6">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="marks2">City</label>-->
<!--                                                    <input type="text" class="form-control dash-input" id="marks2"-->
<!--                                                           placeholder="Enter Your City" name="marks">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="row">-->
<!--                                            <div class="col-md-6 col-sm-6">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="marks3">when are you willing to-->
<!--                                                        join</label>-->
<!--                                                    <input type="text" class="form-control dash-input" id="marks3"-->
<!--                                                           placeholder="Enter Detail" name="marks">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div class="col-md-6 col-sm-6">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="marks">CGPA or Marks</label>-->
<!--                                                    <input type="text" class="form-control dash-input" id="marks"-->
<!--                                                           placeholder="Enter CGPA or Marks" name="marks">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="row">-->
<!--                                            <div class="col-md-12">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="skills">Skills</label>-->
<!--                                                    <input type="text" class="form-control dash-input" id="skills"-->
<!--                                                           placeholder="Enter Your Skills" name="marks">-->
<!--                                                    &lt;!&ndash;                        <input type="text" class="form-control dash-input" id="skills"&ndash;&gt;-->
<!--                                                    &lt;!&ndash;                               placeholder="Skills" name="skills">&ndash;&gt;-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="row">-->
<!--                                            <div class="col-md-12">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="cw">what are you currently-->
<!--                                                        working</label>-->
<!--                                                    <input type="text" class="form-control dash-input" id="cw"-->
<!--                                                           placeholder="Enter Detail" name="marks">-->
<!--                                                    &lt;!&ndash;                        <input type="text" class="form-control dash-input" id="skills"&ndash;&gt;-->
<!--                                                    &lt;!&ndash;                               placeholder="Skills" name="skills">&ndash;&gt;-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div class="col-md-12">-->
<!--                                                <div class="form-group text-center">-->
<!--                                                    <button class="update-profile" type="submit">Submit Details</button>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="tab-pane fade" id="academic" role="tabpanel"-->
<!--                                         aria-labelledby="academic-tab">-->
<!--                                        <div class="row">-->
<!--                                            <div class="col-md-6 col-sm-6">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="marks1">Profile</label>-->
<!--                                                    <input type="text" class="form-control dash-input" id="marks1"-->
<!--                                                           placeholder="Enter CGPA or Marks" name="marks">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div class="col-md-6 col-sm-6">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="marks2">City</label>-->
<!--                                                    <input type="text" class="form-control dash-input" id="marks2"-->
<!--                                                           placeholder="Enter CGPA or Marks" name="marks">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="row">-->
<!--                                            <div class="col-md-6 col-sm-6">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="marks3">when are you willing to-->
<!--                                                        join</label>-->
<!--                                                    <input type="text" class="form-control dash-input" id="marks3"-->
<!--                                                           placeholder="Enter CGPA or Marks" name="marks">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div class="col-md-6 col-sm-6">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="marks">CGPA or Marks</label>-->
<!--                                                    <input type="text" class="form-control dash-input" id="marks"-->
<!--                                                           placeholder="Enter CGPA or Marks" name="marks">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="row">-->
<!--                                            <div class="col-md-12">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="skills">Skills</label>-->
<!--                                                    <input type="text" class="form-control dash-input" id="skills"-->
<!--                                                           placeholder="Enter CGPA or Marks" name="marks">-->
<!--                                                    &lt;!&ndash;                        <input type="text" class="form-control dash-input" id="skills"&ndash;&gt;-->
<!--                                                    &lt;!&ndash;                               placeholder="Skills" name="skills">&ndash;&gt;-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="row">-->
<!--                                            <div class="col-md-12">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="cw">what are you currently-->
<!--                                                        working</label>-->
<!--                                                    <input type="text" class="form-control dash-input" id="cw"-->
<!--                                                           placeholder="Enter CGPA or Marks" name="marks">-->
<!--                                                    &lt;!&ndash;                        <input type="text" class="form-control dash-input" id="skills"&ndash;&gt;-->
<!--                                                    &lt;!&ndash;                               placeholder="Skills" name="skills">&ndash;&gt;-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div class="col-md-12">-->
<!--                                                <div class="form-group text-center">-->
<!--                                                    <button class="update-profile" type="submit">Submit Details</button>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="tab-pane fade" id="general" role="tabpanel"-->
<!--                                         aria-labelledby="general-tab">-->
<!--                                        <p>last</p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="row poll-main"
                         v-if="this.$store.getters.getUser['education_loan'] && !this.$store.getters.getUser['is_viewed']">
                        <div class="col-md-3">
                            <div class="poll-image-m">
                                <img
                                    src="https://shshank.eygb.me/assets/themes/ey/images/pages/educational-loans/edu-loan-icon.png"/>
                            </div>
                        </div>
                        <div class="col-md-9">
                            <div class="poll-question">
                                <h2>Looking for Education loan? Let us help you find the best loan scheme with low
                                    interest rate available for all study programs in India/Abroad.</h2>
                            </div>
                            <div class="poll-answers">
                                <router-link to="/dashboard/education-loan" class="poll-primary-action">Interested
                                </router-link>
                                <!--                                <button type="button">-->
                                <!--                                    Enquire Now-->
                                <!--                                </button>-->
                                <a href="javascript:;" class="poll-primary-default" @click="notInterested()">
                                    Thanks, I'm not interested
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="this.$store.getters.getPreferences['show_teachers']">
                        <div class="col-md-6">
                            <h1 class="main-heading">Today’s Class Schedule</h1>
                        </div>
                        <div class="col-md-6">
                            <button type="button" class="btn btn-primary reload-main" @click="getClasses()"><i
                                class="fas fa-sync-alt"></i></button>
                        </div>
                    </div>

                    <div class="row" v-if="this.$store.getters.getPreferences['show_teachers']">
                        <div class="col-md-12" v-if="todayClasses.length">
                            <div class="col-md-6" v-for="cl in todayClasses">
                                <div class="today-schedule" :class="((cl.is_live || cl.seconds < 0) ? 'is-live' : '')">
                                    <i class="fas fa-broadcast-tower"></i>
                                    <h3 class="ts-title">{{ cl.subject_name }}</h3>
                                    <h4 class="ts-title">{{ cl.course_name }}</h4>
                                    <span class="section">By {{ cl.teacher_name }}</span>
                                    <p v-if="!cl.is_live" v-html="showTime(cl.start_time)+' to '+showTime(cl.end_time)">
                                    </p>
                                    <p v-else class="live-description">Live Class</p>
                                    <a class="join-button join" href="javascript:;" v-bind:data-key="cl.class_enc_id"
                                       @click="joinClass($event)" v-if="cl.is_started">
                                        <span>Join Now</span>
                                        <span>
                                          <svg width="20px" height="12px" viewBox="0 0 66 43" version="1.1"
                                               xmlns="http://www.w3.org/2000/svg"
                                               xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <g id="arrow" stroke="none" stroke-width="1" fill="none"
                                               fill-rule="evenodd">
                                              <path class="one"
                                                    d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                                                    fill="#FFFFFF"></path>
                                              <path class="two"
                                                    d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                                                    fill="#FFFFFF"></path>
                                              <path class="three"
                                                    d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                                                    fill="#FFFFFF"></path>
                                            </g>
                                          </svg>
                                        </span>
                                    </a>
                                    <a class="join-button" href="javascript:;" v-else>
                                        <span>Stay Tuned</span>
                                    </a>
                                    <div class="count-number">
                                        <span class="date" v-html="getDate(cl.class_date)"></span>
                                        <span class="month" v-html="getMonth(cl.class_date)"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" v-else><h3>No classes scheduled today</h3></div>
                    </div>
                    <div class="row padd-top-50"
                         v-if="this.$store.getters.getPreferences['show_jobs'] || this.$store.getters.getPreferences['show_internships']">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h1>Applied Applications</h1>
                                        </div>
                                    </div>
                                </div>
                                <div class="row padd-top-10">
                                    <div class="col-md-12" v-if="appData.length">
                                        <div class="m-widget4 m-widget4--progress">
                                            <div class="m-widget4__item row" v-for="appliedApplications in appData">
                                                <div class="m-widget4__img m-widget4__img--pic col-md-1">
                                                    <img :src="appliedApplications.icon"
                                                         :alt="appliedApplications.title">
                                                </div>
                                                <div class="m-widget4__info col-md-6">
                                            <span class="m-widget4__title">
                                                {{ appliedApplications.title }} ( {{
                                                    appliedApplications.type
                                                }} )                                             </span><br>
                                                    <span class="m-widget4__sub" v-html="appliedApplications.org_name"></span>
                                                </div>
                                                <div class="m-widget4__ext col-md-1">
                                                    <a class="m-btn m-btn--hover-brand m-btn--pill btn btn-sm reject_btn"
                                                       v-if="appliedApplications.status == 'Rejected'"
                                                       v-html="'Rejected'" disabled></a>
                                                    <a style="font-size: 11px;" href="javascript:;"
                                                       v-if="appliedApplications.status == 'Rejected' && appliedApplications.rejection_reasons && appliedApplications.rejection_reasons.candidateRejectionReasons.length"
                                                       :data-key="appliedApplications.applied_application_enc_id"
                                                       @click="showReasons($event)">Show Reasons</a>
                                                    <a class="m-btn m-btn--hover-brand m-btn--pill btn btn-sm reject_btn"
                                                       v-if="appliedApplications.status == 'Cancelled'"
                                                       v-html="'Cancelled'" disabled></a>
                                                    <a class="m-btn m-btn--hover-brand m-btn--pill btn btn-sm hired_btn"
                                                       v-else-if="appliedApplications.status == 'Hired'"
                                                       v-html="'Hired'" disabled></a>
                                                    <a class="m-btn m-btn--hover-brand m-btn--pill btn btn-sm btn-secondary cancel-app"
                                                       :data-key="appliedApplications.applied_application_enc_id"
                                                       v-else-if="appliedApplications.status == 'Pending' || appliedApplications.status == 'Incomplete'"
                                                       @click="cancelApplication($event)">
                                                        Cancel
                                                    </a>
                                                </div>
                                                <div class="m-widget4__progress col-md-4">
                                                    <div class="m-widget4__progress-wrapper">
                                                        <span class="m-widget17__progress-number">{{
                                                                appliedApplications.per
                                                            }}%</span>
                                                        <span class="m-widget17__progress-label">{{
                                                                appliedApplications.status
                                                            }}</span>
                                                        <div class="progress m-progress--sm">
                                                            <div class="progress-bar bg-danger" role="progressbar"
                                                                 :style="'width: '+appliedApplications.per+'%;'"
                                                                 :aria-valuenow="appliedApplications.per"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 text-center" v-else>
                                        <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                                        <h2 class="no-data-found">No Applications Applied Yet</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row padd-top-50" v-if="questionnaireList.length">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading mb-0">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h1>Questionnaires</h1>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <table class="table table-bordered">
                                            <thead>
                                            <th>For</th>
                                            <th>Round</th>
                                            <th>Choose Questionnaire</th>
                                            </thead>
                                            <tr v-for="ql in questionnaireList">
                                                <td>{{ ql.title }}</td>
                                                <td>{{ ql.current_round }}</td>
                                                <td>
                                                    <router-link
                                                        :to="{path: '/dashboard/fill-questionnaire?id=' + oneQl.questionnaire_enc_id+'&aid=' + ql.applied_application_enc_id}"
                                                        class="ss-button" v-for="oneQl in ql.question">
                                                        {{ oneQl.questionnaire_name }}
                                                    </router-link>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--                    <div class="row padd-top-20">-->
                    <!--                        <div class="col-md-12">-->
                    <!--                            <div class="dash-inner-box">-->
                    <!--                                <div class="dashboard-heading">-->
                    <!--                                    <div class="row">-->
                    <!--                                        <div class="col-md-6">-->
                    <!--                                            <h1>Competitions</h1>-->
                    <!--                                        </div>-->
                    <!--                                    </div>-->
                    <!--                                </div>-->
                    <!--                                <div class="row padd-top-10">-->
                    <!--                                    <div class="col-md-12 mb-20">-->
                    <!--                                        <div class="col-md-6">-->
                    <!--                                            <router-link to="/edupreneur">-->
                    <!--                                                <img src="images/ev.png" class="img-responsive"/>-->
                    <!--                                            </router-link>-->
                    <!--                                        </div>-->
                    <!--                                        <div class="col-md-6">-->
                    <!--                                            <router-link to="/redbull-basement-2020">-->
                    <!--                                                <img src="images/redbull.png" class="img-responsive"/>-->
                    <!--                                            </router-link>-->
                    <!--                                        </div>-->
                    <!--                                    </div>-->
                    <!--                                </div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <div class="row padd-top-50" v-if="this.$store.getters.getPreferences['show_jobs']">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h1>Applied Jobs</h1>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="view-all" v-if="jobs.length">
                                                <router-link to="/dashboard/applied">View All</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row padd-top-10">
                                    <div class="col-md-12" v-if="jobs.length">
                                        <div class="col-md-4" v-for="job in jobs">
                                            <div class="job-box">
                                                <div class="jb-com-icon">
                                                    <router-link :to="{path: '/profile?slug=' + job.comp_slug}">
                                                        <img v-bind:src="job.logo" :alt="job.organization_name"/>
                                                    </router-link>
                                                </div>
                                                <div class="jb-com-name">
                                                    <router-link :to="{path: '/profile?slug=' + job.comp_slug}" v-html="job.organization_name"></router-link>
                                                </div>
                                                <div class="jb-job-title">
                                                    <span v-html="job.title"></span>
                                                    <div v-if="job.is_exclusive"
                                                         class="tooltip-main labelImg display-inline-block">
                                                        <img src="images/all-jobs/exclusive.png" width="30" hspace="5"/>
                                                        <span class="tooltiptext tooltip-bottom">Exclusive</span>
                                                    </div>
                                                </div>
                                                <div class="jb-job-location">
                                                    <i class="fas fa-map-marker-alt"></i> {{ job.cities }}
                                                </div>
                                                <!--                                                <div class="jb-job-positions">-->
                                                <!--                                                    {{job.cnt}} Positions-->
                                                <!--                                                </div>-->
                                                <div class="jb-view-details">
                                                    <router-link :to="{path: '/detail?id=' + job.slug}">
                                                        View Job Detail
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 text-center" v-else>
                                        <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                                        <h2 class="no-data-found">No Jobs Applied Yet</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row padd-top-50" v-if="this.$store.getters.getPreferences['show_internships']">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h1>Applied Internships</h1>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="view-all" v-if="jobs.length">
                                                <router-link to="/dashboard/applied-internships">View All</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row padd-top-10">
                                    <div class="col-md-12" v-if="internships.length">
                                        <div class="col-md-4" v-for="job in internships">
                                            <div class="job-box">
                                                <div class="jb-com-icon">
                                                    <router-link :to="{path: '/profile?slug=' + job.comp_slug}">
                                                        <img v-bind:src="job.logo" :alt="job.organization_name"/>
                                                    </router-link>
                                                </div>
                                                <div class="jb-com-name">
                                                    <router-link :to="{path: '/profile?slug=' + job.comp_slug}" v-html="job.organization_name"></router-link>
                                                </div>
                                                <div class="jb-job-title">
                                                    <span v-html="job.title"></span>
                                                    <div v-if="job.is_exclusive"
                                                         class="tooltip-main labelImg display-inline-block">
                                                        <img src="images/all-jobs/exclusive.png" width="30" hspace="5"/>
                                                        <span class="tooltiptext tooltip-bottom">Exclusive</span>
                                                    </div>
                                                </div>
                                                <div class="jb-job-location">
                                                    <i class="fas fa-map-marker-alt"></i> {{ job.cities }}
                                                </div>
                                                <!--                                                <div class="jb-job-positions">-->
                                                <!--                                                    {{job.cnt}} Positions-->
                                                <!--                                                </div>-->
                                                <div class="jb-view-details">
                                                    <router-link :to="{path: '/detail?id=' + job.slug}">
                                                        View Internship Detail
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 text-center" v-else>
                                        <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                                        <h2 class="no-data-found">No Internships Applied Yet</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row padd-top-50" v-if="shortlistedApp.length">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h1>Shortlisted Applications</h1>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="view-all" v-if="shortlistedApp.length">
                                                <router-link to="/dashboard/shortlisted-applications">View All
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row padd-top-10">
                                    <div class="col-md-12" v-if="shortlistedApp.length">
                                        <div class="col-md-4" v-for="job in shortlistedApp">
                                            <div class="job-box">
                                                <div class="jb-com-icon">
                                                    <router-link :to="{path: '/profile?slug=' + job.comp_slug}">
                                                        <img v-bind:src="job.logo" :alt="job.name"/>
                                                    </router-link>
                                                </div>
                                                <div class="jb-com-name">
                                                    <router-link :to="{path: '/profile?slug=' + job.org_slug}" v-html="job.name">

                                                    </router-link>
                                                </div>
                                                <span class="stamp is-nope"
                                                      v-if="job.is_closed">Recruitment Completed</span>
                                                <div class="jb-job-title">
                                                    <span v-html="job.title"></span>
                                                    <div v-if="job.is_exclusive"
                                                         class="tooltip-main labelImg display-inline-block">
                                                        <img src="images/all-jobs/exclusive.png" width="30" hspace="5"/>
                                                        <span class="tooltiptext tooltip-bottom">Exclusive</span>
                                                    </div>
                                                </div>
                                                <div class="jb-job-location">
                                                    <i class="fas fa-map-marker-alt"></i> {{ job.location }}
                                                </div>
                                                <div class="jb-job-positions">
                                                    {{ job.positions }} Positions
                                                </div>
                                                <div class="jb-view-details">
                                                    <router-link :to="{path: '/detail?id=' + job.slug}">
                                                        View <span v-if="job.job_type == 'Jobs'">Job</span><span v-else>Internship</span>
                                                        Detail
                                                    </router-link>
                                                    <div v-if="job.filling_soon && !job.is_closed"
                                                         class="tooltip-main labelImg display-inline-block">
                                                        <img src="images/all-jobs/filling-soon.png" width="15"
                                                             hspace="5"/>
                                                        <span class="tooltiptext tooltip-bottom">Filling Soon</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 text-center" v-else>
                                        <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                                        <h2 class="no-data-found">No Applications Shortlisted Yet</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row padd-top-50"
                         v-if="this.$store.getters.getPreferences['show_jobs'] && this.$store.getters.getPreferences['show_internships']">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <h1>Followed Companies</h1>
                                </div>
                                <div class="row padd-top-10">
                                    <div class="col-md-12" v-if="company.length">
                                        <div class="col-md-4 col-sm-6" v-for="c in company">
                                            <div data-aos="fade-zoom-in" class="cp-com-box">
                                                <div class="cp-com-logo">
                                                    <router-link
                                                        :to="{path: '/profile?slug=' + c.organizationEnc.org_slug}">
                                                        <img
                                                            v-bind:src="c.organizationEnc.logo" alt="">
                                                    </router-link>
                                                </div>
                                                <div class="jb-com-name">
                                                    <router-link :to="{path: '/profile?slug=' + c.organizationEnc.org_slug}" v-html="c.organizationEnc.organization_name"></router-link>
                                                </div>
                                                <div class="cp-com-category">
                                                    {{ c.organizationEnc.business_activity }}
                                                </div>
                                                <div class="cp-com-opper">
                                                    Jobs Available : <span>{{ c.organizationEnc.jobs_count }}</span>
                                                </div>
                                                <div class="cp-com-opper">
                                                    Internships Available :
                                                    <span>{{ c.organizationEnc.internships_count }}</span>
                                                </div>
                                                <div class="cp-view-btn">
                                                    <a v-bind:href="'/dashboard/all-jobs?slug=' + c.organizationEnc.org_slug">View
                                                        Jobs</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 text-center" v-else>
                                        <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                                        <h2 class="no-data-found">No Companies Followed Yet</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--                    <div class="row">-->
                    <!--                        <div class="col-md-12">-->
                    <!--                            <div class="dash-inner-box">-->
                    <!--                                <div class="dashboard-heading">-->
                    <!--                                    <h1>Quizzes</h1>-->
                    <!--                                </div>-->
                    <!--                                <div class="row padd-top-10">-->
                    <!--                                    <div class="col-md-12" v-if="quizzes.length">-->
                    <!--                                        <div class="quizTable">-->
                    <!--                                            <table>-->
                    <!--                                                <thead>-->
                    <!--                                                <tr>-->
                    <!--                                                    <th class="sno">#</th>-->
                    <!--                                                    <th class="quizName">Quiz Name</th>-->
                    <!--                                                    <th class="noQuse">No. of Questions</th>-->
                    <!--                                                    <th class="tMarks" >Total Marks</th>-->
                    <!--                                                    <th class="time" >Time Limit (In Minutes)</th>-->
                    <!--                                                    <th class="timetaken" >Time Taken</th>-->
                    <!--                                                    <th class="result">Results</th>-->
                    <!--                                                </tr>-->
                    <!--                                                </thead>-->
                    <!--                                                <tbody>-->
                    <!--                                                <tr v-for="(quiz, index) in quizzes">-->
                    <!--                                                    <td class="sno">{{index + 1}}</td>-->
                    <!--                                                    <td>{{quiz.name}}</td>-->
                    <!--                                                    <td>{{quiz.total_questions}}</td>-->
                    <!--                                                    <td>{{quiz.total_marks}}</td>-->
                    <!--                                                    <td>{{quiz.total_time}}</td>-->
                    <!--                                                    <td>{{quiz.timeTaken}}</td>-->
                    <!--                                                    <td>-->
                    <!--                                                        <div v-if="quiz.is_played">-->
                    <!--                                                            <span v-if="quiz.obtained_marks" v-html="quiz.obtained_marks"></span><span v-else>0 </span> / {{quiz.total_marks}}-->
                    <!--                                                        </div>-->
                    <!--                                                        <div class="view-all" v-else>-->
                    <!--                                                            <router-link :to="{path: '/dashboard/quiz-view?id=' + quiz.quiz_enc_id}">Take Quiz</router-link>-->
                    <!--                                                        </div>-->
                    <!--                                                    </td>-->
                    <!--                                                </tr>-->
                    <!--                                                </tbody>-->
                    <!--                                            </table>-->
                    <!--                                        </div>-->
                    <!--                                    </div>-->
                    <!--                                    <div id="not-found" class="col-md-12 text-center hidden" v-else>-->
                    <!--                                        <img src="images/dashboard/no_data_found.png" class="no-data-found"/>-->
                    <!--                                        <h2 class="no-data-found">No Quizzes Found</h2>-->
                    <!--                                    </div>-->
                    <!--                                </div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <div class="row padd-top-50"
                         v-if="this.$store.getters.getPreferences['show_jobs'] && this.$store.getters.getPreferences['show_internships']">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <h1>Featured Companies </h1>
                                </div>
                                <div class="ca-pos-rel" v-if="companies.length">
                                    <div class="ca-box">
                                        <div class="com-avail-box" v-for="c in companies">
                                            <div class="ca-com-logo">
                                                <router-link
                                                    :to="{path: '/profile?slug=' + c.organizationEnc.org_slug}"><img
                                                    v-bind:src="c.organizationEnc.logo"/>
                                                </router-link>
                                            </div>
                                            <div class="ca-com-detail">
                                                <router-link
                                                    :to="{path: '/profile?slug=' + c.organizationEnc.org_slug}" v-html="c.organizationEnc.organization_name"></router-link>
                                                <ul class="ca-com-opper">
                                                    <li>{{ c.organizationEnc.jobs_count }} Jobs</li>
                                                    <li>{{ c.organizationEnc.internships_count }} Internships</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-else>
                                    <div class="col-md-12 text-center">
                                        <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                                        <h2 class="no-data-found">Your college has not approved any company yet</h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--            <div class="col-md-7">-->
                        <!--                <div class="dash-inner-box">-->
                        <!--                    <div class="dashboard-heading">-->
                        <!--                        <h1>Recent Activity</h1>-->
                        <!--                    </div>-->
                        <!--                    <div class="ra-pos-rel">-->
                        <!--                        <div class="ra-sec">-->
                        <!--                            <ul>-->
                        <!--                                <li>-->
                        <!--                                    Our Resume Updated!Dobrick Published An Article Published An Article Published An Article-->
                        <!--                                    <p>2 Hours ago</p>-->
                        <!--                                </li>-->
                        <!--                                <li>-->
                        <!--                                    Our Resume Updated!Dobrick Published An Article Published An Article Published An Article-->
                        <!--                                    <p>2 Hours ago</p>-->
                        <!--                                </li>-->
                        <!--                                <li>-->
                        <!--                                    Our Resume Updated!Dobrick Published An Article Published An Article Published An Article-->
                        <!--                                    <p>2 Hours ago</p>-->
                        <!--                                </li>-->
                        <!--                                <li>-->
                        <!--                                    Our Resume Updated!Dobrick Published An Article Published An Article Published An Article-->
                        <!--                                    <p>2 Hours ago</p>-->
                        <!--                                </li>-->
                        <!--                                <li>-->
                        <!--                                    Our Resume Updated!Dobrick Published An Article Published-->
                        <!--                                    <p>2 Hours ago</p>-->
                        <!--                                </li>-->
                        <!--                                <li>-->
                        <!--                                    Our Resume Updated!Dobrick Published An Article Published-->
                        <!--                                    <p>2 Hours ago</p>-->
                        <!--                                </li>-->
                        <!--                                <li>-->
                        <!--                                    Our Resume Updated!Dobrick Published An Article Published An Article Published An Article-->
                        <!--                                    <p>2 Hours ago</p>-->
                        <!--                                </li>-->
                        <!--                                <li>-->
                        <!--                                    Our Resume Updated!Dobrick Published An Article Published An Article Published An Article-->
                        <!--                                    <p>2 Hours ago</p>-->
                        <!--                                </li>-->
                        <!--                                <li>-->
                        <!--                                    Our Resume Updated!Dobrick Published An Article Published An Article Published An Article-->
                        <!--                                    <p>2 Hours ago</p>-->
                        <!--                                </li>-->
                        <!--                            </ul>-->
                        <!--                        </div>-->
                        <!--                    </div>-->
                        <!--                </div>-->
                        <!--            </div>-->
                    </div>
                </div>
            </div>
        </div>
        <div id="rejectReasonModal" class="modal" data-backdrop="static" data-keyboard="false">
            <div class="mecpopup-container">
                <div class="mecpopup-popup" role="dialog">
                    <div class="mecpopup-olay"></div>
                    <button class="mecpopup-close" title="Close" @click="modalClose">
                        <svg width="16" height="16" viewBox="0 0 16 16">
                            <g stroke="#777" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round">
                                <path d="M4 12L12 4M4 4l8 8"></path>
                            </g>
                        </svg>
                    </button>
                    <div class="mecpopup-content-main">
                        <div class="mecpopup-content">
                            <div class="mecpopup-inner-content">
                                <div class="mecpopup-column">
                                    <div class="mecpopup-fields">
                                        <div class="mecpopup-fields-inner">
                                            <div class="mecpopup-block-text">
                                                <div data-contents="true">
                                                    <div>
                                    <span
                                        style="font-weight: 700; font-size: 32px; font-family: Lato; color: rgb(0, 0, 0);">
                                        <span data-text="true">Rejection Detail</span>
                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mecpopup-fields" v-if="Object.keys(rejectReasons).length">
                                        <div class="mecpopup-fields-inner">
                                            <div class="mecpopup-block-text">
                                                <div>
                                                    <h5 style="margin-top: 20px;margin-bottom: 20px;">Rejection Type:
                                                        <strong v-if="rejectReasons.rejection_type == 1">Permanent
                                                            Reject</strong><strong
                                                            v-if="rejectReasons.rejection_type == 2">Consider for Other
                                                            Job</strong><strong
                                                            v-if="rejectReasons.rejection_type == 3">Save for
                                                            Later</strong></h5>
                                                </div>
                                                <div>
                                                    <h3 class="mecpopup-s-title">Reasons</h3>
                                                    <div class="tags"
                                                         style="font-size: 16px; font-family: Lato; font-weight: 400; letter-spacing: normal; line-height: 180%; color: rgba(0, 0, 0, 0.52); background-color: transparent;">
                                        <span v-for="rr in rejectReasons.candidateRejectionReasons">
                                          {{ rr.reason }}
                                        </span>
                                                    </div>
                                                </div>
                                                <div v-if="rejectReasons.considerJobs.length">
                                                    <h3 class="mecpopup-s-title">Considered Applications</h3>
                                                    <div class="col-md-12">
                                                        <div class="col-sm-6 app-list-data-main"
                                                             v-for="cj in rejectReasons.considerJobs">
                                                            <router-link :to="{path: '/detail?id=' + cj.slug}"
                                                                         class="job_listing" @click="modalClose">
                                                                <div class="inner-list-main">
                                                                    <div class="job-listing-company-logo">
                                                                        <img class="company_logo" :src="cj.logo"
                                                                             :alt="cj.title">
                                                                    </div>
                                                                    <div class="job-details">
                                                                        <div class="job-details-inner">
                                                                            <div class="job-listing-company company"
                                                                                 :title="cj.title">
                                                                                <strong>{{ cj.title }}</strong>
                                                                            </div>
                                                                            <div class="job-location location">
                                                                                <span
                                                                                    :title="cj.parent_category">{{
                                                                                        cj.parent_category
                                                                                    }}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </router-link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import toastr from "../../../public/js/toastr";
import CandidateBanner from "../../components/candidateBanner";
import CandidateSideNavLayout from '../../components/CandidateSideNavLayout.vue';
import updatesModal from '../../components/updateRequiredDetail.vue';
import firebase from "firebase";
import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";
import webinarWidget from "@/components/webinarWidget";
import educationLoanWebinar from "@/components/educationLoanWebinar";

export default {
    components: {
        CandidateBanner,
        CandidateSideNavLayout,
        // educationLoanWebinar,
        // webinarWidget,
        updatesModal
    },
    data: function () {
        return {
            //variables for count section
            jobs_count: '',
            company_count: '',
            shortlist_count: '',
            todayClasses: [],

            //variables for company section
            companies: [],

            //variable for jobs section
            jobs: [],
            internships: [],
            shortlistedApp: [],
            rejectReasons: {},

            //variable for followed companies
            company: [],

            //variable for firebase
            specialKey: 'BnE3860mWdnBEZMLXlwkdjw9A2K5DJ',
            db: firebase.database(),
            quizzes: [],
            appData: [],
            questionnaireList: [],
        }
    },
    created() {

    },
    mounted() {
        if (this.validateUser()) {
            $('#updatesModal').modal('show');
        }
        var user = this.$store.getters.getUser;
        var t = this;
        var url = this.$store.getters.getDomain;

        $('.ca-box').perfectScrollbar();
        $('.ra-sec').perfectScrollbar();

        //api request for counts
        axios({
            method: 'POST',
            url: `${url}api/v2/candhome/get-data`,
            headers: requestHeaders()
        })
            .then(function (data) {
                t.jobs_count = data['data']['response']['applied_cnt'][0]['applied_count'];
                t.company_count = data['data']['response']['companies_cnt'][0]['companies_count'];
                t.shortlist_count = data['data']['response']['shortlisted_cnt'][0]['shortlisted_cnt'];
                if (data['data']['response']['organization'].length) {
                    t.companies = data['data']['response']['organization'];
                }
                if (data['data']['response']['applied_jobs']) {
                    t.jobs = data['data']['response']['applied_jobs'];
                }
                if (data['data']['response']['applied_internships']) {
                    t.internships = data['data']['response']['applied_internships'];
                }
                if (data['data']['response']['followed']) {
                    t.company = data['data']['response']['followed'];
                }
            })
            .catch(function (error) {
                // console.log(error)
            })
        if (this.$store.getters.getPreferences['show_teachers']) {
            t.getClasses();
            var commentsRef = t.db.ref(t.specialKey + '/classes/' + t.$store.getters.getUser['college_enc_id']);
            commentsRef.on('value', gotData1, errData1);

            function gotData1(data) {
                var result2 = [];
                for (var i in data.val()) {
                    result2.push([i, data.val()[i]]);
                }
                for (var z = 0; z < result2.length; z++) {
                    if (result2[z][1].course == t.$store.getters.getUser['course_enc_id']) {
                        t.getClasses();
                        return false;
                    }
                }
            };

            function errData1(data) {
                console.log('err');
            }
        }
        // this.getQuizzesList();
        this.getAppliedProcess();
        this.getQuestionnaireList();
        this.getShortlistedAppList();
    },
    methods: {
        modalClose() {
            $('#rejectReasonModal').modal('hide');
        },
        getClasses() {
            document.getElementsByClassName('reload-main')[0].children[0].classList += " fa-spin";
            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/candhome/online-classes`, "", {headers: requestHeaders()}).then(function (response) {
                t.todayClasses = [];
                if (response['data']['response']['status'] == 200) {
                    t.todayClasses = response['data']['response']['data'];
                    if (response['data']['response']['data'][0]['seconds'] > 2) {
                        var timeLeft = response['data']['response']['data'][0]['seconds'] * 1000;
                        setTimeout(function () {
                            t.getClasses();
                        }, timeLeft)
                    }
                }
                document.getElementsByClassName('reload-main')[0].children[0].classList.remove('fa-spin');
            });
        },
        joinClass(event) {
            var t = this;
            showLoader();
            var element = event.currentTarget;
            var url = this.$store.getters.getDomain;
            var data_key = element.getAttribute('data-key');

            var data = {'class_id': data_key}
            axios.post(`${url}api/v2/classes/get-student-session`, data, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.$router.push({path: '/dashboard/stream?cid=' + data_key + '&id=' + response['data']['response']['session_id']})
                } else {
                    hideLoader();
                    toastr.error('Your teacher has not started class yet, Please Wait or Try Again', 'Oops!!');
                }
            });
        },
        getDate(e) {
            var d = new Date(e);
            return d.getDate();
        },
        getMonth(e) {
            var d = new Date(e);
            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            return months[d.getMonth()];
        },
        showTime(e) {
            return e.replace(/:[^:]*$/, '');
        },
        showReasons(event) {
            var t = this;
            var element = event.currentTarget;
            var id = element.getAttribute('data-key');
            for (var p = 0; p < t.appData.length; p++) {
                if (t.appData[p].applied_application_enc_id == id) {
                    t.rejectReasons = t.appData[p].rejection_reasons;
                    $('#rejectReasonModal').modal('show');
                    return true;
                }
            }
        },
        getQuizzesList() {
            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/quiz/get-quizzes`, "", {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.quizzes = response['data']['response']['data'];
                } else {
                    if (document.getElementById("not-found")) {
                        document.getElementById("not-found").classList.remove('hidden');
                    }
                }
            });
        },
        getQuestionnaireList() {
            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/candhome/questionnaire`, "", {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.questionnaireList = response['data']['response']['data'];
                }
            });
        },
        getShortlistedAppList() {
            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/candhome/shortlisted-applications`, {limit: 6}, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.shortlistedApp = response['data']['response']['shortlisted'];
                }
            });
        },
        notInterested() {
            this.$store.getters.getUser['is_viewed'] = true;
            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/candhome/not-interested`, "", {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {

                }
            });
        },
        getAppliedProcess() {
            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/jobs/process-bar`, "", {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.appData = response['data']['response']['data'];
                }
            });
        },
        cancelApplication(event) {
            var element = event.currentTarget;
            element.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
            var id = element.getAttribute('data-key');
            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/jobs/cancel-job`, {applied_application_id: id}, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.getAppliedProcess();
                    toastr.success('Application Cancelled', 'Success');
                } else {
                    toastr.error('Some error occurred. Try again later', 'Oops!!');
                }
            });
        },
        validateUser() {
            if (this.$store.getters.getUser['user_type'] == "Individual" && this.$store.getters.getUser['user_other_detail'] == false) {
                return true;
            } else {
                return false;
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        this.modalClose();
        next();
    }
}
</script>

<style scoped>
.ps-container .ps-scrollbar-x-rail {
    display: none !important;
}

.ps-container .ps-scrollbar-x {
    display: none;
}

.reload-main {
    background-color: #00a0e3;
    margin: 10px;
    float: right;
    margin-top: 25px;
    border-color: #00a0e3;
    border-radius: 10px 0px 10px 0;
}

.reload-main:hover {
    border-radius: 0px;
    -webkit-transition: .5s all;
    transition: .5s all;
    background-color: #00a0e3;
    border-color: #00a0e3;
}

.today-schedule {
    padding: 40px 40px 40px 50px;
    -webkit-box-shadow: 0px 20px 25px 0px rgba(0, 0, 0, 0.08);
    box-shadow: 0px 20px 25px 0px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -ms-border-radius: 5px;
    overflow: hidden;
    position: relative;
    background: #fff;
    z-index: 2;
    margin-bottom: 30px;
}

.today-schedule i {
    position: absolute;
    right: -10px;
    top: 20px;
    font-size: 55px;
    color: #bababa;
}

h3.ts-title {
    font-size: 24px;
    margin-bottom: 4px;
}

h4.ts-title {
    color: #777;
}

.today-schedule span.section {
    color: silver;
    text-transform: uppercase;
    margin-bottom: 10px;
    display: block;
}

.today-schedule p {
    margin-bottom: 0;
}

.today-schedule .count-number, .schedule-slot-time .count-number {
    position: absolute;
    left: -52px;
    top: -52px;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -ms-border-radius: 50%;
    background: #00a0e3;
    color: #fff;
    display: block;
    text-align: left;
    font-size: 16px;
    font-weight: 700;
    padding-left: 63px;
    padding-top: 63px;
}

.today-schedule.is-live .count-number {
    background: #e45e05;
}

.count-number > span {
    display: block;
}

.count-number > span.date {
    margin-bottom: 0;
    margin-left: 10px;
}

.today-schedule {
    transition: 0.5s;
    -webkit-box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.08);
    box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.08);
}

.live-description {
    color: #e45e05;
    font-weight: 600;
}

.join-button {
    display: inline-block;
    padding: 10px 25px;
    text-decoration: none;
    position: relative;
    font-size: 15px;
    color: white;
    background: #00a0e3;
    border-radius: 20px;
    transition: 1s;
    box-shadow: 0px 7px 25px 0px rgba(0, 0, 0, 0.22);
    margin: 10px 0px;
}

.is-live .join-button {
    background: #e45e05;
}

.join-button.join {
    padding-right: 10px;
}

.join-button span:nth-child(2) {
    transition: 0.5s;
    margin-right: 0px;
}

.join-button:hover span:nth-child(2) {
    transition: 0.5s;
    margin-right: 20px;
}

.join-button span:nth-child(2) {
    width: 20px;
    margin-left: 10px;
    position: relative;
    top: 12%;
}

.today-schedule:hover {
    -webkit-box-shadow: 0px 10px 35px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 10px 35px 0px rgba(0, 0, 0, 0.15);
}

.today-schedule:hover > i {
    animation: shake 0.9s;
    animation-iteration-count: infinite;
}

@keyframes shake {
    0% {
        transform: translate(1px, 1px) rotate(0deg);
    }
    10% {
        transform: translate(-1px, -2px) rotate(-1deg);
    }
    20% {
        transform: translate(-3px, 0px) rotate(1deg);
    }
    30% {
        transform: translate(3px, 2px) rotate(0deg);
    }
    40% {
        transform: translate(1px, -1px) rotate(1deg);
    }
    50% {
        transform: translate(-1px, 2px) rotate(-1deg);
    }
    60% {
        transform: translate(-3px, 1px) rotate(0deg);
    }
    70% {
        transform: translate(3px, 1px) rotate(-1deg);
    }
    80% {
        transform: translate(-1px, -1px) rotate(1deg);
    }
    90% {
        transform: translate(1px, 2px) rotate(0deg);
    }
    100% {
        transform: translate(1px, -2px) rotate(-1deg);
    }
}

/**************SVG****************/

.join-button path.one {
    transition: 0.4s;
    transform: translateX(-60%);
}

.join-button path.two {
    transition: 0.5s;
    transform: translateX(-30%);
}


.join-button:hover path.one {
    transform: translateX(0%);
}

.join-button:hover path.two {
    transform: translateX(0%);
}

.sno {
    width: 5%;
    text-align: center;
}

.quizName {
    width: 30%;
}

.result {
    width: 15%;
}

.noQuse, .tMarks, .time, .timetaken {
    width: 10%;
}

.quizTable {
    padding: 0 15px 15px;
}

table {
    width: 100%;
    border-collapse: collapse;
}

/* Zebra striping */
tr:nth-of-type(odd) {
    background: #f7f7f7;
}

th {
    background: #00a0e3;
    color: #fff;
    font-weight: 500;
    padding: 10px 8px;
}

td, th {
    padding: 10px 8px;
    border: 1px solid #eee;
    text-align: left;
}

.quizTable .view-all {
    float: left;
}

@media only screen and (max-width: 760px),
(min-device-width: 768px) and (max-device-width: 1024px) {

    /* Force table to not be like tables anymore */
    table, thead, tbody, th, td, tr {
        display: block;
    }

    /* Hide table headers (but not display: none;, for accessibility) */
    thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
    }

    tr {
        border: 1px solid #ccc;
    }

    td {
        /* Behave  like a "row" */
        border: none;
        border-bottom: 1px solid #eee;
        position: relative;
        padding-left: 50%;
    }

    td:before {
        /* Now like a table header */
        position: absolute;
        /* Top/left values mimic padding */
        top: 6px;
        left: 6px;
        width: 45%;
        padding-right: 10px;
        white-space: nowrap;
    }

    /*
    Label the data
    */
    td:nth-of-type(1):before {
        content: "First Name";
    }

    td:nth-of-type(2):before {
        content: "Last Name";
    }

    td:nth-of-type(3):before {
        content: "Job Title";
    }

    td:nth-of-type(4):before {
        content: "Favorite Color";
    }

    td:nth-of-type(5):before {
        content: "Wars of Trek?";
    }

    td:nth-of-type(6):before {
        content: "Secret Alias";
    }

    td:nth-of-type(7):before {
        content: "Date of Birth";
    }

    td:nth-of-type(8):before {
        content: "Dream Vacation City";
    }

    td:nth-of-type(9):before {
        content: "GPA";
    }

    td:nth-of-type(10):before {
        content: "Arbitrary Data";
    }
}

.poll-main {
    margin: 10px 0px;
    padding: 30px 10px;
    border-radius: 5px;
    background-color: #356BAB;
}

.poll-image-m img {
    width: 100%;
}

.poll-question h2 {
    font-size: 22px;
    color: #fff;
    font-weight: 700;
    margin-bottom: 15px;
}

.poll-answers .poll-primary-action {
    background-color: #fff;
    border-radius: 30px;
    padding: 12px 30px;
    font-weight: 500;
    border: 0px;
    display: inline-block;
    text-transform: uppercase;
    margin-right: 15px;
}

.poll-answers .poll-primary-default {
    font-family: Lato;
    font-size: 12px;
    font-weight: 400;
    margin: 10px;
    text-decoration: underline;
    color: #fff;
    display: block;
}

.m-widget4 .m-widget4__item {
    display: block;
    padding-top: 1.15rem;
    padding-bottom: 1.25rem;
}

.m-widget4__item {
    border-bottom: 0.07rem dashed #ebedf2;
}

.m-widget4 .m-widget4__item .m-widget4__img {
    display: block;
    float: left;
}

.m-widget4 .m-widget4__item .m-widget4__img.m-widget4__img--pic img {
    width: 4rem;
    border-radius: 50%;
    margin-left: 10px;
}

.m-widget4 .m-widget4__item .m-widget4__info {
    display: block;
    float: left;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    font-size: 1rem;
}

.m-widget4 .m-widget4__item .m-widget4__info .m-widget4__title {
    font-size: 15px;
    font-weight: 500;
    color: #575962;
    font-family: roboto;
}

.m-widget4 .m-widget4__item .m-widget4__ext {
    display: block;
    float: right;
    padding: 0px;
    width: 11%;
}

.btn.m-btn--pill {
    border-radius: 60px !important;
}

.btn.btn-secondary {
    background: white !important;
    border-color: #ebedf2 !important;
    box-shadow: none !important;
    color: #212529;
    -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out !important;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out !important;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out !important;
}

.m-widget4.m-widget4--progress .m-widget4__progress {
    padding-right: 2rem;
    width: 30%;
    display: block;
    position: relative;
}

.m-widget4.m-widget4--progress .m-widget4__progress .m-widget4__progress-wrapper .m-widget17__progress-number {
    font-size: 13px;
    font-weight: 500;
    font-family: roboto;
}

.m-widget4.m-widget4--progress .m-widget4__progress .m-widget4__progress-wrapper .m-widget17__progress-label {
    font-size: 12px;
    float: right;
    margin-top: 0.3rem;
    font-family: roboto;
    font-weight: 500;
}

.page-md .progress {
    text-indent: -99999px;
}

.m-widget4.m-widget4--progress .m-widget4__progress .m-widget4__progress-wrapper .progress {
    display: block;
    margin-top: 0.8rem;
    height: 0.5rem;
    overflow: hidden;
    font-size: .75rem;
    background-color: #e9ecef;
    border-radius: 0 !important;
    border: 0;
    background-image: none;
    filter: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
}

.progress-bar {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    background-color: #5867dd;
    -webkit-transition: width 0.6s ease;
    transition: width 0.6s ease;
}

.progress.m-progress--sm .progress-bar {
    border-radius: 3px;
}

.progress .progress-bar {
    -webkit-transition: all 0.5s ease;
    transition: all 0.5s ease;
}

.bg-danger {
    background-color: #f4516c !important;
}

.hired_btn {
    color: #fdfbfb;
    background: #26c281 !important;
}

.reject_btn {
    color: #fdfbfb;
    background: #e43a45 !important;
}

td a.ss-button {
    margin: 2px 5px;
    display: inline-block;
}

.mecpopup-popup {
    width: 600px;
}

.mecpopup-content {
    padding: 30px 40px !important;
}

.tags span {
    background-color: #00a0e3;
    color: #fff;
    padding: 8px 18px;
    border-radius: 20px;
    margin: 5px;
    display: inline-block;
}

.mecpopup-s-title {
    font-weight: 700;
    color: #222;
    font-size: 17px;
    display: block;
    line-height: normal;
    margin-top: 30px;
    margin-bottom: 15px;
}

.job_listing {
    padding-left: 0;
    width: 100%;
    margin-bottom: 0px;
}

.job_listing > .inner-list-main {
    padding: 12px 0px;
    border-bottom: 1px solid #edeff7;
    margin: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-transition: all 0.4s ease 0s;
    transition: all 0.4s ease 0s;
    border-top: 1px solid transparent;
}

.app-list-data-main:first-child > .job_listing > .inner-list-main, .app-list-data-main:nth-child(2) > .job_listing > .inner-list-main, .app-list-data-main:nth-child(3) > .job_listing > .inner-list-main, .set-borders:nth-child(4) > .job_listing > .inner-list-main {
    border-top: 1px solid #edeff7;
}

.job-listing-company-logo {
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 0px;
    padding-left: 0px;
    text-align: center;
}

.job-listing-company-logo img {
    object-fit: contain;
}

.job-listing-company-logo img, .job-listing-company-logo {
    width: 35px;
    height: 35px;
}

.job-listing-company-logo {
    max-width: 40px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 40px;
    flex: 0 0 40px;
    margin-bottom: 0;
}

.job-details {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    color: #717f86;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.job-details {
    -ms-flex-preferred-size: 0;
    flex-basis: 0%;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    max-width: calc(100% - 40px);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
}

.job-details-inner {
    line-height: 1.6;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
}

.job-details-inner {
    padding-right: 15px;
    -webkit-box-flex: inherit;
    -ms-flex: inherit;
    flex: inherit;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.job-details-inner .job-listing-company.company {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    line-height: inherit;
}

.job-listing-company strong {
    text-transform: capitalize;
}

.job-details-inner .job-location {
    font-size: 13px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.job-details-inner .job-location.location {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-align: inherit;
    -ms-flex-align: inherit;
    align-items: inherit;
}

.job_listing > .inner-list-main:hover, .job_listing > .inner-list-main:focus {
    color: initial;
    box-shadow: 0 0 30px rgb(0 0 0 / 10%);
}


/*tabs css starts*/

ul.material-tabs {
    position: relative;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: flex;
    margin: 0 auto;
    padding: 0;
    max-width: 1200px;
    list-style: none;
    -ms-box-orient: horizontal;
    -ms-box-pack: center;
    -webkit-flex-flow: row wrap;
    -moz-flex-flow: row wrap;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    justify-content: center;
    overflow: hidden;
    border-top-left-radius: 2.25rem;
    border-top-right-radius: 2.25rem;
    background: rgba(0, 0, 0, 0.05);
}

ul.material-tabs li {
    position: relative;
    z-index: 1;
    display: block;
    margin: 0;
    text-align: center;
    -webkit-flex: 1;
    -moz-flex: 1;
    -ms-flex: 1;
    flex: 1;
    margin: 0 3em;
}

ul.material-tabs li.active {
    z-index: 9;
}

ul.material-tabs li:first-child {
    margin-left: 0;
}

ul.material-tabs li.current {
    z-index: 9;
}

ul.material-tabs li a {
    position: relative;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 20px;
    border: 0px !important;
}

ul.material-tabs li a {
    overflow: visible;
    margin: 0 -3em 0 0;
    padding: 0;
    color: #fff;
    font-weight: 500;
}

ul.material-tabs li.active a {
    color: #333;
}

svg:not(:root) {
    overflow: hidden;
}

ul.material-tabs li a svg {
    position: absolute;
    left: 100%;
    margin: 0;
    width: 3em;
    height: 100%;
    fill: #bdc2c9;
}

ul.material-tabs li a svg {
    pointer-events: none;
}

ul.material-tabs li.active a span,
ul.material-tabs li.active a svg {
    -webkit-transition: none;
    transition: none;
}

ul.material-tabs li.active a svg {
    fill: #fff;
}

ul.material-tabs li a svg use {
    pointer-events: auto;
}

ul.material-tabs a span {
    vertical-align: middle;
    font-size: 0.75em;
}

ul.material-tabs li a span {
    display: block;
    overflow: hidden;
    padding: 0.65em 0;
    background-color: #bdc2c9;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 15px;
}

ul.material-tabs li:first-child a span {
    padding-left: 2em;
    border-radius: 30px 0 0 0;
}

ul.material-tabs li.active a span {
    background: #fff;
}

ul.material-tabs li a svg:nth-child(2),
ul.material-tabs li:last-child a svg {
    right: 99%;
    left: auto;
    -webkit-transform: scale3d(-1, 1, 1);
    transform: scale3d(-1, 1, 1);
}

.tab-int-data {
    border-top-left-radius: 2.25rem;
    border-top-right-radius: 2.25rem;
    box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);
    -webkit-box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);
}

.tab-int-data > .tab-content {
    padding: 20px 30px;
}
.tab-pane.fade.show{
    display: none !important;
}
.tab-pane.fade.show.active.in{
    display: block !important;
}
/*tabs css ends*/
</style>